import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import Select from "react-select/creatable";
import CONSTANTS from "../utils/constants";

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "40px",
    borderRadius: "0.375rem",
    borderColor: state.isFocused ? "#F47D39" : "#cccc",
    boxShadow: state.isFocused
      ? "0 0 0 0.25rem rgba(244, 125, 57, 0.25)"
      : null,
    "&:hover": {
      borderColor: "#F47D39",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#F47D39"
      : state.isFocused
      ? "#e9ecef"
      : null,
    color: state.isSelected ? "white" : "black",
  }),
};

export default function AdminOrderLocation() {
  const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [newLocation, setNewLocation] = useState({ 
    region: "", 
    city: "",
    city_en: "",
    city_ru: ""
  });
  const [editingLocationId, setEditingLocationId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalLocationData, setModalLocationData] = useState({
    region: "",
    city: "",
    city_en: "",
    city_ru: ""
  });
  const [userPermissions, setUserPermissions] = useState([]);
  const [message, setMessage] = useState("");
  const [activeLanguage, setActiveLanguage] = useState("tm");
  const [loading, setLoading] = useState(true);

  // Null değerleri temizleme fonksiyonu
  const sanitizeData = (data) => {
    return {
      region: data.region || "",
      city: data.city || "",
      city_en: data.city_en || "",
      city_ru: data.city_ru || ""
    };
  };

  // Bölge seçeneklerini dinamik olarak oluştur
  const getRegionOptions = () => {
    const uniqueRegions = [...new Set(locations.map((loc) => loc.region))];
    return uniqueRegions.map((region) => ({
      value: region,
      label: region,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = Cookies.get("user")
          ? JSON.parse(Cookies.get("user"))
          : null;
        if (!user?.id) {
          navigate("/admin");
          return;
        }

        const permissionsResponse = await axios.get(
          `${CONSTANTS.baseRoute}/permissions`,
          {
            params: { user_id: user.id },
          }
        );
        const permissions = permissionsResponse.data.permissions;
        setUserPermissions(permissions);

        if (!permissions.includes(19)) {
          setMessage("Bu sahypany görmek üçin rugsadyňyz ýok");
          navigate("/admin/home");
          return;
        }

        await fetchLocations();
      } catch (error) {
        console.error("Error fetching data:", error);
        setMessage("Maglumatlary ýüklep bolmady.");
        setTimeout(() => setMessage(""), 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  const fetchLocations = async () => {
    try {
      console.log("Fetching locations from:", `${CONSTANTS.baseRoute}/locations`);
      const response = await axios.get(`${CONSTANTS.baseRoute}/locations`);
      
      // Null değerleri temizle
      const sanitizedLocations = response.data.map(location => ({
        ...location,
        city: location.city || "",
        city_en: location.city_en || "",
        city_ru: location.city_ru || "",
        region: location.region || ""
      }));
      
      console.log("Sanitized locations:", sanitizedLocations);
      setLocations(sanitizedLocations);
    } catch (error) {
      console.error("Error fetching locations:", error);
      const errorMessage = error.response?.data?.error || error.message || "Mekanlary getirmede näsazlyk döredi.";
      setMessage(errorMessage);
      setTimeout(() => setMessage(""), 5000);
    }
  };

  const handleAddLocation = async (e) => {
    e.preventDefault();
    if (!userPermissions.includes(20)) {
      setMessage("Bu hereketi ýerine ýetirmek üçin rugsadyňyz ýok");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    const sanitizedData = sanitizeData(newLocation);
    
    if (!sanitizedData.region || !sanitizedData.city) {
      setMessage("Welaýat we Köçe/etrap hökman dolduryň!");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    try {
      const response = await axios.post(`${CONSTANTS.baseRoute}/locations`, {
        welayat: sanitizedData.region,
        etrap: sanitizedData.city,
        etrap_en: sanitizedData.city_en || sanitizedData.city,
        etrap_ru: sanitizedData.city_ru || sanitizedData.city,
      });
      
      // Yeni lokasyonu listeye eklemeden önce sanitize et
      const sanitizedNewLocation = sanitizeData(response.data);
      setLocations((prev) => [...prev, sanitizedNewLocation]);
      
      // Formu temizle
      setNewLocation({ region: "", city: "", city_en: "", city_ru: "" });
      setMessage("Täze salgy üstünlikli goşuldy!");
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Error adding location:", error);
      const errorMessage = error.response?.data?.error || error.message || "Salgy goşmada näsazlyk döredi.";
      setMessage(errorMessage);
      setTimeout(() => setMessage(""), 5000);
    }
  };

  const handleDeleteLocation = async (id) => {
    if (!userPermissions.includes(22)) {
      setMessage("Bu hereketi ýerine ýetirmek üçin rugsadyňyz ýok");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    if (!window.confirm("Bu salgyny pozmaga ynamyňyz barmy?")) return;

    try {
      await axios.delete(`${CONSTANTS.baseRoute}/locations/${id}`);
      setLocations((prev) => prev.filter((loc) => loc.id !== id));
      setMessage("Salgy üstünlikli pozuldy!");
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Error deleting location:", error);
      const errorMessage = error.response?.data?.error || error.message || "Salgy pozmada näsazlyk döredi.";
      setMessage(errorMessage);
      setTimeout(() => setMessage(""), 5000);
    }
  };

  const handleEditLocation = (location) => {
    if (!userPermissions.includes(21)) {
      setMessage("Bu hereketi ýerine ýetirmek üçin rugsadyňyz ýok");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    setEditingLocationId(location.id);
    setModalLocationData(sanitizeData({
      region: location.region,
      city: location.city,
      city_en: location.city_en,
      city_ru: location.city_ru
    }));
    setShowModal(true);
  };

  const handleSaveModalChanges = async (e) => {
    e.preventDefault();
    if (!userPermissions.includes(editingLocationId ? 21 : 20)) {
      setMessage("Bu hereketi ýerine ýetirmek üçin rugsadyňyz ýok");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    const sanitizedData = sanitizeData(modalLocationData);
    
    if (!sanitizedData.region || !sanitizedData.city) {
      setMessage("Welaýat we Köçe/etrap hökman dolduryň!");
      setTimeout(() => setMessage(""), 3000);
      return;
    }

    try {
      const payload = {
        welayat: sanitizedData.region,
        etrap: sanitizedData.city,
        etrap_en: sanitizedData.city_en || sanitizedData.city,
        etrap_ru: sanitizedData.city_ru || sanitizedData.city,
      };

      let response;
      if (editingLocationId) {
        response = await axios.put(
          `${CONSTANTS.baseRoute}/locations/${editingLocationId}`,
          payload
        );
        const updatedLocation = sanitizeData(response.data);
        setLocations((prev) =>
          prev.map((loc) =>
            loc.id === editingLocationId ? updatedLocation : loc
          )
        );
        setMessage("Köçe/etrap üstünlikli täzelendi!");
      } else {
        response = await axios.post(
          `${CONSTANTS.baseRoute}/locations`,
          payload
        );
        const newLocation = sanitizeData(response.data);
        setLocations((prev) => [...prev, newLocation]);
        setMessage("Täze Köçe/etrap üstünlikli goşuldy!");
      }
      
      setTimeout(() => setMessage(""), 3000);
      handleCloseModal();
    } catch (error) {
      console.error("Error saving location:", error);
      const errorMessage = error.response?.data?.error || error.message || "Ýazmakda näsazlyk döredi.";
      setMessage(errorMessage);
      setTimeout(() => setMessage(""), 5000);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingLocationId(null);
    setModalLocationData({ region: "", city: "", city_en: "", city_ru: "" });
  };

  const getCityDisplayName = (location) => {
    const sanitizedLocation = sanitizeData(location);
    switch (activeLanguage) {
      case "tm": return sanitizedLocation.city;
      case "en": return sanitizedLocation.city_en || sanitizedLocation.city;
      case "ru": return sanitizedLocation.city_ru || sanitizedLocation.city;
      default: return sanitizedLocation.city;
    }
  };

  if (loading) {
    return (
      <div className="admin-main p-4 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Ýüklenýär...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-main ps-2 pe-3 py-2">
      <div className="d-flex gap-2 align-items-center mb-2">
        <button className="btn btn-light" onClick={() => navigate(-1)}>
          <i className="bi bi-chevron-left"></i>
        </button>
        <button className="btn btn-light" onClick={() => navigate(+1)}>
          <i className="bi bi-chevron-right"></i>
        </button>
        <h5 className="fw-bold">Sargytlaryň ýerleri</h5>
        
        <div className="ms-auto btn-group">
          <button 
            type="button" 
            className={`btn btn-sm ${activeLanguage === 'tm' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setActiveLanguage('tm')}
          >
            TM
          </button>
          <button 
            type="button" 
            className={`btn btn-sm ${activeLanguage === 'en' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setActiveLanguage('en')}
          >
            EN
          </button>
          <button 
            type="button" 
            className={`btn btn-sm ${activeLanguage === 'ru' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setActiveLanguage('ru')}
          >
            RU
          </button>
        </div>
      </div>

      {message && (
        <div
          className={`alert ${
            message.includes("üstünlikli") ? "alert-success" : "alert-danger"
          }`}
        >
          {message}
        </div>
      )}

      <div className="row">
        <div className={userPermissions.includes(20) ? "col-lg-6 mb-4" : "col-12 mb-4"}>
          <div className="card shadow-sm">
            <div className="card-header text-white fw-bolder" style={{ backgroundColor: "#F47D39" }}>
              Bar bolan Ýerler
            </div>
            <div className="card-body p-0">
              <table className="table table-hover text-center mb-0">
                <thead style={{ backgroundColor: "#F47D39", color: "#fff" }}>
                  <tr>
                    <th>Welaýat</th>
                    <th>Köçe ({activeLanguage.toUpperCase()})</th>
                    <th className="text-end">Amallar</th>
                  </tr>
                </thead>
                <tbody>
                  {locations.length > 0 ? (
                    locations.map((location) => (
                      <tr
                        key={location.id}
                        style={{
                          cursor: userPermissions.includes(21) ? "pointer" : "default",
                        }}
                        onClick={(e) => {
                          if (
                            e.target.tagName.toLowerCase() === "button" ||
                            e.target.tagName.toLowerCase() === "i"
                          )
                            return;

                          if (userPermissions.includes(21)) {
                            handleEditLocation(location);
                          }
                        }}
                      >
                        <td>{location.region}</td>
                        <td>{getCityDisplayName(location)}</td>
                        <td className="text-end">
                          {userPermissions.includes(21) && (
                            <button
                              onClick={() => handleEditLocation(location)}
                              className="btn btn-sm btn-outline-primary me-2"
                            >
                              <i className="bi bi-pencil-fill"></i>
                            </button>
                          )}
                          {userPermissions.includes(22) && (
                            <button
                              onClick={() => handleDeleteLocation(location.id)}
                              className="btn btn-sm btn-outline-danger"
                            >
                              <i className="bi bi-trash-fill"></i>
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4">
                        Ýer tapylmady.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {userPermissions.includes(20) && (
          <div className="col-lg-6 mb-4">
            <div className="card shadow-sm">
              <div className="card-header fw-bolder" style={{ backgroundColor: "#F47D39", color: "#fff" }}>
                Täze Ýer Goşmak
              </div>
              <div className="card-body">
                <form onSubmit={handleAddLocation}>
                  <Select
                    isClearable
                    isSearchable
                    options={getRegionOptions()}
                    value={
                      newLocation.region
                        ? { value: newLocation.region, label: newLocation.region }
                        : null
                    }
                    onChange={(selected) =>
                      setNewLocation((prev) => ({
                        ...prev,
                        region: selected?.value || "",
                      }))
                    }
                    onCreateOption={(inputValue) => {
                      setNewLocation((prev) => ({
                        ...prev,
                        region: inputValue,
                      }));
                    }}
                    placeholder="Welaýat saýla ýa-da täze ýaz..."
                    className="mb-3"
                    styles={customSelectStyles}
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="city"
                    value={newLocation.city || ""}
                    onChange={(e) =>
                      setNewLocation((prev) => ({
                        ...prev,
                        city: e.target.value,
                      }))
                    }
                    placeholder="Köçe / Etrap (Türkmen)"
                    required
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="city_en"
                    value={newLocation.city_en || ""}
                    onChange={(e) =>
                      setNewLocation((prev) => ({
                        ...prev,
                        city_en: e.target.value,
                      }))
                    }
                    placeholder="Köçe / Etrap (English)"
                  />
                  <input
                    type="text"
                    className="form-control mb-3"
                    name="city_ru"
                    value={newLocation.city_ru || ""}
                    onChange={(e) =>
                      setNewLocation((prev) => ({
                        ...prev,
                        city_ru: e.target.value,
                      }))
                    }
                    placeholder="Köçe / Etrap (Русский)"
                  />
                  <button
                    type="submit"
                    className="btn btn-success w-100"
                  >
                    Ýatda sakla
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>

      {showModal && (
        <>
          <div className="custom-modal-backdrop fade show"></div>
          <div
            className={`modal fade ${showModal ? "show" : ""} d-block custom-modal-animation`}
            tabIndex="-1"
          >
            <div className="modal-dialog custom-modal-dialog">
              <div className="modal-content">
                <div className="modal-header d-flex justify-content-between">
                  <h5 className="modal-title">Ýeri Üýtget</h5>
                  <i
                    className="bi bi-x-lg"
                    style={{ cursor: "pointer" }}
                    onClick={handleCloseModal}
                  ></i>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSaveModalChanges}>
                    <Select
                      isClearable
                      isSearchable
                      options={getRegionOptions()}
                      value={
                        modalLocationData.region
                          ? { value: modalLocationData.region, label: modalLocationData.region }
                          : null
                      }
                      onChange={(selected) =>
                        setModalLocationData((prev) => ({
                          ...prev,
                          region: selected?.value || "",
                        }))
                      }
                      onCreateOption={(inputValue) =>
                        setModalLocationData((prev) => ({
                          ...prev,
                          region: inputValue,
                        }))
                      }
                      placeholder="Welaýat saýla ýa-da täze ýaz..."
                      className="mb-3"
                      styles={customSelectStyles}
                    />
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="city"
                      value={modalLocationData.city || ""}
                      onChange={(e) =>
                        setModalLocationData((prev) => ({
                          ...prev,
                          city: e.target.value,
                        }))
                      }
                      placeholder="Köçe / Etrap (Türkmen)"
                      required
                    />
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="city_en"
                      value={modalLocationData.city_en || ""}
                      onChange={(e) =>
                        setModalLocationData((prev) => ({
                          ...prev,
                          city_en: e.target.value,
                        }))
                      }
                      placeholder="Köçe / Etrap (English)"
                    />
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="city_ru"
                      value={modalLocationData.city_ru || ""}
                      onChange={(e) =>
                        setModalLocationData((prev) => ({
                          ...prev,
                          city_ru: e.target.value,
                        }))
                      }
                      placeholder="Köçe / Etrap (Русский)"
                    />
                    <button type="submit" className="btn btn-success w-100">
                      Ýatda sakla
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}